import React from "react";
import capitalize from "lodash/capitalize";

type TitleProps = {
  firstName: string | null;
  testerRank: TesterRank;
};

type TesterRank = {
  tierCode: string;
  tierPayoutMultiplier: number;
};

const Title = ({ firstName, testerRank }: TitleProps) => (
  <div className="border-b border-body py-xl px-2xl">
    <div data-testid="tester-name">
      <p className="mr-sm mb-0 text-lightest text-lg font-bold">{firstName || "Tester"}</p>
    </div>
    <p className="mb-0 text-sm text-dark">{currentRanking(testerRank)}</p>
  </div>
);

function currentRanking({ tierCode, tierPayoutMultiplier }: TesterRank) {
  const tierName = capitalize(tierCode);

  return `${tierName}: ${tierPayoutMultiplier}x payout`;
}

export default Title;
